// extracted by mini-css-extract-plugin
module.exports = {"PhotoUpload":"PhotoUpload_PhotoUpload__2_e1D","Img":"PhotoUpload_Img__38uCI"};